import request from "@/utils/request";

// 创建
export const createFileCategory = (data) => {
    return request({
        url: "/businessservice/fileCategory/create",
        method: "post",
        data: data
    })
}

// 更新
export const updateFileCategory = (data) => {
    return request({
        url: "/businessservice/fileCategory/update",
        method: "post",
        data: data
    })
}

// 删除
export const  deleteFileCategory =(query) =>{
    return request({
        url: "/businessservice/fileCategory/delete",
        method:"get",
        params: query
    })
}

// 树查询
export const treeFileCategory = (data) => {
    return request({
        url: "/businessservice/fileCategory/tree",
        method: "post",
        data: data
    })
}

// 分页查询文件
export const pageCategoryFile = (data) => {
    return request({
        url: "/businessservice/fileCategory/pageFile",
        method: "post",
        data: data
    })
}

// 查询文件
export const  infoFile =(query) =>{
    return request({
        url: "/businessservice/fileCategory/infoFile",
        method:"get",
        params: query
    })
}

// 删除文件
export const  deleteFile =(query) =>{
    return request({
        url: "/businessservice/fileCategory/deleteFile",
        method:"get",
        params: query
    })
}